
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gnFk9LDOsUSFctVjYJs7U4M81hw9GpMSO56xXjO_45NNgcMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexs4xBARGF260gtgx0bBzIPTivi_nEqwqwQeBtDSRgaZoMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchKZyAUKD8LupYmX0vPrUKKBjXBWRul0M9d9_kYkpvaNMMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexNvGQ2iE1HJBetXr7bFt2hpfPx6wJzWUhFeoFFDEwV3QMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93J_45uH6nJ9bTAvOwg_45_4524L58opKU7g26_aJQGNmMmq5e8Meta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexvnke5m35AU9J_Bv_7D9KT4ACWmV6OI8xDRpUS894V_458Meta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93nuuoDW_wgWKk3Lla2LHVXvAUtNiBqRTEVG2XMPlbVfoMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexx4_vzq9i4VxvLWS__45gFh_45aaQL02svgOKqpk2Gw9vwNoMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93BIWC3P1zJNj36cfxigD8cmsVfalnXm3QMCMf4Mgl308Meta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_45lD5nwA6B6F_45BEEK7HJ_aNLWO6gqAWeC_tSJF07pWk8Meta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexIUhQhxuy7VD8ZF3rlQp4TvjeVycYCtwPYJNystRtmqQMeta } from "/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexvnke5m35AU9J_Bv_7D9KT4ACWmV6OI8xDRpUS894V_458Meta || {},
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexx4_vzq9i4VxvLWS__45gFh_45aaQL02svgOKqpk2Gw9vwNoMeta || {},
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_45lD5nwA6B6F_45BEEK7HJ_aNLWO6gqAWeC_tSJF07pWk8Meta || {},
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexIUhQhxuy7VD8ZF3rlQp4TvjeVycYCtwPYJNystRtmqQMeta || {},
    component: () => import("/codebuild/output/src2863993933/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]